<script>

const items = {
  'en-cours': {color: 'gray', icon: 'fa-cart-shopping', text: 'Panier'},
  'en-livraison': {color: 'orange', icon: 'fa-truck', text: 'En cours de livraison'},
  'commandé': {color: 'yellow', icon: 'fa-hourglass', text: 'En attente de livraison'},
  'livré': {color: 'green', icon: 'fa-check', text: 'Livré'}
}
export default {
  name: 'StatusDelivery',
  props: {
    workflows: {
      type: Array,
      required: true
    },
    showStatus: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      items
    }
  },
  computed: {
    item () {
      return this.items[this.last.text]
    },
    last () {
      return this.workflows.at(-1)
    }
  }
}
</script>

<template>
  <dl class="w-1/2 sm:w-1/4 lg:w-auto lg:flex-1">
    <dt v-if="showStatus" class="text-base font-medium text-gray-500 dark:text-gray-400">Status:</dt>
    <dd :class="`me-2 mt-1.5 inline-flex items-center rounded bg-${item.color}-100 px-2.5 py-0.5 text-xs font-medium text-${item.color}-800`">
      <i :class="`fa solid ${item.icon} mr-2`"></i>
      {{ item.text }}
    </dd>
  </dl>
</template>

<style scoped>

</style>